export enum Language {
  GERMAN = 'de',
  ENGLISH = 'en',
}
